import { render, staticRenderFns } from "./IconLinkCard.vue?vue&type=template&id=317442e7&scoped=true&"
import script from "./IconLinkCard.vue?vue&type=script&lang=ts&"
export * from "./IconLinkCard.vue?vue&type=script&lang=ts&"
import style0 from "./IconLinkCard.vue?vue&type=style&index=0&id=317442e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317442e7",
  null
  
)

export default component.exports